import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-success-story',
	templateUrl: './success-story.component.html',
	styleUrls: ['./success-story.component.scss']
})
export class SuccessStoryComponent implements OnInit {

	@Input() afterImage: any;
	@Input() beforeImage: any;
	// set afterImg(afterImg: string) {
	// 	this._afterImg = afterImg === undefined ? "../../../../assets/images/service4.svg" : afterImg;
	// }
	// private _afterImg = "../../../../assets/images/service4.svg";

	
	// get beforeImg(): string {
	// 	return this._beforeImg
	// }

	// set beforeImg(beforeImg: string) {
	// 	this._beforeImg = beforeImg === undefined ? "../../../../assets/images/service4.svg" : beforeImg;
	// }
	// private _beforeImg = "../../../../assets/images/service4.svg";

	constructor() { }

	ngOnInit(): void {
	}

}
